import React, { useState } from "react";
import { Icon } from "semantic-ui-react";

import "./MobileToolbar.css"

import { commands$ } from "./CommandsStream";

import { PlayerSubMenu } from "./Toolbar";
import { useRecoilValue } from "recoil";
import { viewingDescription, viewingMobileTransport } from "./atoms";
import { Waveform } from "./Waveform";
import { Info } from "./Info";

export const mobileHeight = "calc(100% - 72px)"

export function MobileToolbar() {
  const [menuShown, setMenuShown] = useState(false);

  const transportShown = useRecoilValue(viewingMobileTransport);
  const descriptionShown = useRecoilValue(viewingDescription);

  const listShown = !transportShown && !descriptionShown

  return <>
    <nav className="tab-bar">
      <Icon name="bars" size="big" onClick={() => {
        setMenuShown(true);
      }} />

      <Info />

      <Icon name="th" size="big"
        color={listShown ? "teal" : undefined}
        onClick={() => {
          commands$.showPlaylist();
        }} />
      <Icon name="play" size="big"
        color={transportShown ? "teal" : undefined}
        onClick={() => {
          commands$.showMobileTransport();
        }} />
      <Icon name="info" size="big"
        color={descriptionShown ? "teal" : undefined}
        onClick={() => {
          commands$.showDescription();
        }} />

      <PlayerSubMenu
        open={menuShown}
        onClose={() => setMenuShown(false)}
      />
    </nav>

    <div style={{ display: "none" }}><Waveform id="waveform" /></div>
  </>
}